export const stylesLoader = {
  position: 'relative',
  backgroundColor: '#f9f9f9',
  height: '85vh',
};
